import React, { useRef, useEffect } from "react";

const ProductsSearchBar = ({ searchQuery, setSearchQuery, totalCount }) => {
  const inputRef = useRef(null);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key === "k") {
        e.preventDefault();
        inputRef.current?.focus();
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  return (
    <div className="revamp-search-bar">
      <div className="revamp-search-bar__wrapper">
        <svg
          className="revamp-search-bar__icon"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="11" cy="11" r="8" />
          <line x1="21" y1="21" x2="16.65" y2="16.65" />
        </svg>
        <input
          ref={inputRef}
          type="text"
          className="revamp-search-bar__input"
          placeholder="Search products by name, category, or description..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
        {searchQuery && (
          <button
            className="revamp-search-bar__clear"
            onClick={() => setSearchQuery("")}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        )}
        <span className="revamp-search-bar__shortcut">Ctrl+K</span>
      </div>
      {totalCount > 0 && (
        <span className="revamp-search-bar__count">
          {totalCount} product{totalCount !== 1 ? "s" : ""}
        </span>
      )}
    </div>
  );
};

export default ProductsSearchBar;
